import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'

// Fired from the page rather than from <Experiment>: the hero mounts both its
// desktop and mobile layouts, so the variant subtree renders twice per view.
export const useTrackPrcng1266Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(EXPERIMENT_FLAG)
  }, [])
}
